import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Calculator } from 'lucide-react';
import Logo from './Logo';

const Footer = () => {
  const { pathname } = useLocation();
  if (pathname === '/quote-generator') return null;

  return (
    <footer className="bg-slate-900 text-white pt-20 pb-8 px-4 md:px-12 shrink-0">
    <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 mb-16">
      <div className="lg:col-span-4">
        <Logo className="mb-6 scale-90 origin-left brightness-0 invert" />
        <p className="text-slate-400 text-sm leading-relaxed max-w-sm">
          Premium bearing distribution making production faster and cheaper. Contact us for global supply chain solutions.
        </p>
      </div>
      
      <div className="lg:col-span-2">
        <h4 className="text-[10px] uppercase text-slate-500 font-bold tracking-widest mb-6">Company</h4>
        <ul className="space-y-4 text-sm text-slate-300">
          <li><Link to="/about" className="hover:text-white transition">About Us</Link></li>
          <li><Link to="/" className="hover:text-white transition">Products</Link></li>
          <li><Link to="/quote-generator" className="hover:text-white transition flex items-center gap-2">
            Quote Generator
            <Calculator size={14} className="text-red-500" />
          </Link></li>
          <li><Link to="/admin" className="hover:text-white transition">Admin Login</Link></li>
        </ul>
      </div>

      <div className="lg:col-span-6">
        <h4 className="text-[10px] uppercase text-slate-500 font-bold tracking-widest mb-6">Contact</h4>
        <div className="flex flex-col gap-4 text-sm text-slate-300">
          <div className="flex flex-col">
            <span className="text-[10px] uppercase text-slate-500 font-bold mb-1">Email</span>
            <a href="mailto:obc_chennai@yahoo.com" className="hover:text-white transition">obc_chennai@yahoo.com</a>
            <a href="mailto:obcchennai1@gmail.com" className="hover:text-white transition">obcchennai1@gmail.com</a>
          </div>
          <div className="flex flex-col">
            <span className="text-[10px] uppercase text-slate-500 font-bold mb-1">Phone</span>
            <a href="tel:+919894675226" className="hover:text-white transition">+91 98946 75226</a>
            <a href="tel:+919381025226" className="hover:text-white transition">+91 93810 25226</a>
          </div>
          <div className="flex flex-col">
            <span className="text-[10px] uppercase text-slate-500 font-bold mb-1">Head Office</span>
            <span>New No. 63, Old No. 31, Armenian St, Parry's Corner, George Town, Chennai, Tamil Nadu 600001</span>
          </div>
        </div>
      </div>
    </div>
    
    <div className="max-w-7xl mx-auto pt-8 border-t border-slate-800 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-slate-500">
      <p>© 2026 Onkar Bearing Company. All rights reserved.</p>
      <div className="flex gap-6 uppercase tracking-widest font-bold">
        <a href="#" className="hover:text-white transition">Terms</a>
        <a href="#" className="hover:text-white transition">Privacy</a>
      </div>
    </div>
  </footer>
  );
};

export default Footer;
